<div class="center">
    <div class="arrowTabs" style="width : 100% !important;">
        <a class="finished" style="cursor: default !important;">Step 1: Select Training Method</a>
        <a class="active"  style="cursor: default !important;">Step 2 : Upload Supporting Files</a>
        <a  style="cursor: default !important;">Step 3 : Pre-process and Train the System</a>


    </div>
</div>
<br /><br />

<div class="col-lg-12">
            
    <div class="card" style="width:49%;float:left;min-height:500px;height:auto!important;">
        <h3 class="heading2" style="text-align:center;">Upload New Excel Files</h3>
        <br><br>

        <form 
            enctype="multipart/form-data" class="dropzone" id="dropzoneForm" 
            style="width:auto;margin:0 40px;position:relative;height:auto;"
            [dropzone]="config" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
            <div class="dz-default dz-message">
                <img src="./assets/static/upload.png"><br><br>
                <span style="color:#808080 !important;" >
                    <b>Drag and Drop excel files here or click to browse for files</b>                        
                </span>
            </div>
            <div  class="fallback" >

                <!-- <input type="file" (change)="fileChange($event)" multiple value="Upload" class="upload" />
                <br>
                <input type="submit" value="Upload"> -->
            </div>
        </form>


        <br><br /><br><br>

    </div>
    <div class="card" style="width:49%;float:right;min-height:500px;height:auto!important;">
        
        <p class="alert alert-danger" id="successMessage" *ngIf = "result.Error2 != null">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                {{result.Error2}} 
                <a (click)="redirect()" style=" color:#666">( Click here to upload Tax Code Mapping File )</a>
        </p>
        <p class="alert alert-danger" id="successMessage" *ngIf = "result.LabelError != null">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 
            {{result.LabelError}}
            
        </p>

        <h3 class="heading2" style="text-align:center;">Select Excel column to be considered</h3>

        <br>
        <div class="center">
            <table id="myTable" class="table table-bordered table-hover" style="width:auto;margin:0 10px;position:relative;height:auto;">
              <colgroup>
                <col width="45%" />
                <col width="45%" />
                <col width="35%" />
                <col width="10%" />
              </colgroup>
                
                <thead>


                    <tr style="background-color:#F9f9f9;vertical-align:middle;">
                        <th>
                            <div class="center"><b>Sheet_Name</b></div>
                        </th>
                        <th>
                            <div class="center"><b>Column_Name</b></div>
                        </th>
                        <th>
                            <div class="center"><b>Label </b></div>
                        </th>
                        <th>
                            <div class="center"><b>Delete </b></div>
                        </th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="!addedItem">
                        <h3>Please add item</h3>
                    </tr>
                    <tr *ngFor="let item of addedItem; let i = index">
                        <td><div class="center"><input type="text" [(ngModel)]= "item.SheetName"placeholder="Sheet Name" value="{{item.SheetName}}"></div></td>
                        <td><div class="center"><input type="text" [(ngModel)]= "item.ColumnName" placeholder="Column Name" value="{{item.ColumnName}}"></div></td>
                        <td>
                            <div class="center">
                                <select id="0" [(ngModel)]= "item.LabelName" >
                                    <option value="">Choose Label</option>
                                    <option *ngFor="let lab of labelname" value="{{lab}}">{{lab}}</option>
                                </select>
                            </div>
                        </td>
                        <td>
                            <div class="center">
                                <a class="btnDel" style="color:red;cursor:pointer;" (click)="removeFunction(i)">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>


            </table>
          </div>
        <br />
        <button class="btn btn-sm btn-primary buttonStyle2" (click)="AddFunction()" >Add</button>
        <button id="test1" class="btn btn-sm btn-primary buttonStyle2" (click)="Dbinsert()" style="width:120px!important;">Apply Changes</button>
        <!-- <a href="@Url.Action("SelectAlgorithm", "Train")" class="modal-link btn btn-sm btn-primary buttonStyle3">
          <span class="glyphicon glyphicon-cog" style="color:#666;"></span> Select Algorithm </a> -->
        <br/><br><br>
        <form (submit)="preprocessNew()" *ngIf="click">
            <div class="center">
              <button id="preprocess2" type="submit" class="btn btn-lg btn-primary buttonStyle">Pre-Process</button>
            </div>
            <br />
        </form>
        <div class="center" *ngIf="!click">
            <div class="row" style="margin-right: 40px; margin-left: 40px;">
                <div class="col-xs-11">
                    <div id="progress2" class="progress" style="width:100%;height:37px;margin-top:30px;">
            
                        <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                            style="width:100%;">
                        </div>
                    </div>
                </div>
            
                <div class="col-xs-1" style="height:37px;margin-top:30px;padding-left: 0px;margin-left: 0px;margin-bottom: 20px;">
                    <a class="btnDel" style="cursor:pointer;" (click)="CancelTrain()">
                        <i class="fa fa-close" style="font-size:36px;color:red"></i>
                    </a>
                </div>
            </div>
            <h5 id="text" style="color:rgba(128, 128, 128, 0.92)">The process could take a while. Please do not reload this page or navigate to another page.</h5>
            <!-- <div id="t" class="badge">00:00</div> -->
            <br />
            <br />
          </div>
          <div class="center">
                
            <button type="button" *ngIf="enableGetLogs" (click)="OpenLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
                style="margin:30px 60px 30px 60px !important;"  >
                Get Logs
            </button>
        
        </div>
    </div>
</div>
